<template>
	<a-page-header
		style="border: 1px solid rgb(235, 237, 240);"
		:title="detail.networkName"
		@back="() => $router.go(-1)"
	>
		<template slot="subTitle">
			<span :style="{ color: detail.color }">{{ detail.profileName }}</span>
		</template>
		<template slot="tags">
			<a-tag color="blue">
				{{ detail.accountTypeName }}
			</a-tag>
		</template>
		<a-row type="flex" :gutter="24">
			<a-col>
				<a-statistic title="Post" :value="detail.posts" />
			</a-col>
			<a-col>
				<a-statistic title="Images" :value="detail.images" />
			</a-col>
			<a-col>
				<a-statistic title="Videos" :value="detail.videos" />
			</a-col>
			<a-col>
				<a-statistic title="AVG Comments" :value="detail.comments">
					<template #suffix>
						<span> / per post</span>
					</template>
				</a-statistic>
			</a-col>
			<a-col>
				<a-statistic title="AVG Likes" :value="detail.likes">
					<template #suffix>
						<span> / per post</span>
					</template>
				</a-statistic>
			</a-col>
		</a-row>
	</a-page-header>
</template>

<script>
export default {
	name: 'DetailTitle',
	props: {
		detail: {
			type: Object,
			required: true,
		},
	},
	data: function() {
		return {}
	},
}
</script>

<style></style>
